<span (mouseover)="openDialog($event)" (mouseout)="closeDialog($event)">More Info</span>
